import { api } from './cliente.js';

export type FaixaCarga = 'Disponivel' | 'Alocado' | 'Sobrealocado';

export interface CelulaHeatmap {
  recursoId: string;
  recursoNome: string;
  semana: string;
  percentual: number;
  faixa: FaixaCarga;
}

export interface BarraProjetoRecurso {
  projetoId: string;
  alocacoes: { inicio: string; fim: string; cargaHSemana: number }[];
}

export interface LinhaDoTempoRecurso {
  barras: BarraProjetoRecurso[];
  faixaSemanal: FaixaCarga;
}

export interface VeredictoGhostLoad {
  veredictoId: string;
  demandaId: string;
  inicio: string;
  fim: string;
  cargaHSemana: number;
}

export const workloadApi = {
  heatmap: (inicio: string, fim: string, skills?: string[]) => {
    const query = new URLSearchParams({ inicio, fim });
    (skills ?? []).forEach((s) => query.append('skill', s));
    return api.get<CelulaHeatmap[]>(`/workload/heatmap?${query.toString()}`);
  },
  linhaDoTempoRecurso: (recursoId: string, inicio: string, fim: string) =>
    api.get<LinhaDoTempoRecurso>(`/workload/recursos/${recursoId}/linha-do-tempo?inicio=${inicio}&fim=${fim}`),
  ghostLoadPorRecurso: (recursoId: string) => api.get<VeredictoGhostLoad[]>(`/workload/recursos/${recursoId}/ghost-load`),
};
